<template>
  <div class="sign-list-page">
    <div class="nav-wrap">
      <StatusView />
      <div class="navbox">
        <img class="left" src="@/assets/nav/yz_nav_fh.png" alt="" @click="goBack" />
        <div class="title">签到领礼包</div>
      </div>
    </div>
    <div class="nav-placeholder" aria-hidden="true">
      <StatusView />
      <div class="nav-placeholder-bar"></div>
    </div>

    <div class="page-content">
      <div class="banner">
        <img src="@/assets/game/game_sign_list_banner.png" alt="" />
        <div class="banner-text">
          <div class="banner-title">签到福利站</div>
          <div class="banner-desc">连续签到，解锁游戏豪礼</div>
        </div>
      </div>

      <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
        <van-list
          v-model:loading="state.loading"
          :finished="state.finished"
          :immediate-check="false"
          finished-text="没有更多签到礼包了"
          @load="onLoad"
        >
          <div
            v-for="item in state.lists"
            :key="item.id"
            class="sign-card"
            @click="goDetail(item)"
          >
            <div class="game-row">
              <img class="game-icon" :src="item.pic1 || state.defaultImg" alt="" loading="lazy" />
              <div class="game-info">
                <div class="game-name">{{ item.gamename }}</div>
                <div class="game-sub">
                  <span>{{ item.downloadnum }}</span>
                  <span>{{ item.total_times }}日签到</span>
                </div>
              </div>
              <div class="go-btn">去签到</div>
            </div>

            <div class="activity-title">{{ item.title }}</div>
            <div class="activity-time">活动时间：{{ item.start_time_text }} - {{ item.end_time_text }}</div>

            <div class="reward-list">
              <div
                v-for="reward in getPreviewRewards(item.reward_list)"
                :key="reward.id"
                class="reward-item"
              >
                <img class="reward-img" :src="reward.card_image" alt="" loading="lazy" />
                <div class="reward-day">第{{ reward.checkin_time }}天</div>
                <div class="reward-name">{{ reward.excerpt }}</div>
                <div class="reward-remain">剩{{ reward.remain_num }}</div>
              </div>
            </div>
          </div>

          <van-empty
            v-if="showEmpty"
            image="search"
            description="暂无签到礼包"
          />
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive } from "vue";
import { Toast } from "vant";
import router from "@/router";
import StatusView from "@/views/public/StatusView.vue";
import { gameCheckinList } from "@/api/yzgame";
import { getQueryString } from "@/utils/location";
import { detect } from "@/utils/device";
import defaultImg from "@/assets/defaultimg/error2.png";

const state = reactive({
  lists: [],
  loading: false,
  refreshing: false,
  finished: false,
  pagecode: 0,
  totalPage: 1,
  defaultImg,
});

const showEmpty = computed(() => {
  return !state.loading && !state.refreshing && state.finished && state.lists.length === 0;
});

onMounted(() => {
  try {
    if (detect() == "android" || detect() == "harmony") {
      window.JsBridge.setStatusBar("dark");
    } 
  } catch (error) {
    
  }

  onRefresh();
});

const onRefresh = () => {
  state.pagecode = 0;
  state.finished = false;
  state.lists = [];
  onLoad();
};

const onLoad = () => {
  if (state.finished && !state.refreshing) {
    return;
  }

  state.loading = true;
  state.pagecode += 1;
  getList();
};

const getList = () => {
  gameCheckinList({
    pagecode: state.pagecode,
    type: "ios",
  })
    .then((res) => {
      const response = res.data || {};
      if (response.code == "1") {
        const data = response.data || {};
        const lists = Array.isArray(data.lists) ? data.lists : [];
        state.totalPage = Number(data.total_page) || 1;

        if (state.pagecode === 1) {
          state.lists = lists;
        } else {
          state.lists = state.lists.concat(lists);
        }

        state.finished = state.pagecode >= state.totalPage;
      } else {
        Toast(response.msg || "获取签到礼包失败");
        state.finished = true;
      }
    })
    .catch((error) => {
      console.log(error);
      Toast("网络异常，请稍后重试");
      if (state.pagecode > 1) {
        state.pagecode -= 1;
      }
      state.finished = state.lists.length === 0;
    })
    .finally(() => {
      state.loading = false;
      state.refreshing = false;
    });
};

const getPreviewRewards = (rewards) => {
  if (!Array.isArray(rewards)) {
    return [];
  }
  return rewards;
};

const goDetail = (item) => {
  const query = {
    gid: item.gid,
  };
  const token = getQueryString("token");
  if (token) {
    query.token = token;
  }

  router.push({
    path: "/newgamedetail/gamesign",
    query,
  });
};

const goBack = () => {
    if (detect() == "android" || detect() == "harmony") {
      window.document.location = "goBack://";
    } else {
      router.go(-1);
    }
};
</script>

<style>
body {
  background: #eef7ff;
}
</style>

<style scoped>
.sign-list-page {
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(180deg, #e8f8ff 0%, #f6fbff 48%, #eef7ff 100%);
  overflow-x: hidden;
}

.nav-wrap {
  background: rgba(255, 255, 255,1);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;
  width: 100%;
}

.navbox {
  position: relative;
  width: 100%;
  height: 90px;
}

.navbox .left {
  width: 70px;
  height: 70px;
  padding: 10px;
  position: absolute;
  left: 22px;
  top: 50%;
  transform: translateY(-50%);
}

.navbox .title {
  font-size: 30px;
  font-weight: 600;
  color: #333;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.page-content {
  padding: 24px 24px 40px;
}

.nav-placeholder {
  visibility: hidden;
}

.nav-placeholder-bar {
  height: 90px;
}

.banner {
  position: relative;
  width: 100%;
  height: 260px;
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 16px 36px rgba(45, 111, 187, 0.16);
  margin-bottom: 24px;
}

.banner img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.banner-text {
  position: absolute;
  left: 42px;
  top: 84px;
  color: #123047;
  text-shadow: none;
}

.banner-title {
  font-size: 38px;
  line-height: 44px;
  font-weight: 800;
}

.banner-desc {
  color: #52758c;
  font-size: 23px;
  line-height: 34px;
  margin-top: 10px;
}

.sign-card {
  background: #ffffff;
  border: 2px solid #dcefff;
  border-radius: 24px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 10px 28px rgba(45, 111, 187, 0.08);
}

.game-row {
  display: flex;
  align-items: center;
}

.game-icon {
  width: 92px;
  height: 92px;
  border-radius: 18px;
  object-fit: cover;
  background: #eef7ff;
  flex-shrink: 0;
}

.game-info {
  min-width: 0;
  flex: 1;
  margin-left: 18px;
}

.game-name {
  font-size: 30px;
  line-height: 38px;
  color: #172033;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.game-sub {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.game-sub span {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 17px;
  background: #eef8ff;
  color: #4f7188;
  font-size: 22px;
  margin-right: 8px;
}

.go-btn {
  width: 112px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  border-radius: 26px;
  background: linear-gradient(135deg, #30b8ff, #22c4a8);
  color: #ffffff;
  font-size: 24px;
  font-weight: 600;
  flex-shrink: 0;
  margin-left: 12px;
}

.activity-title {
  color: #172033;
  font-size: 28px;
  line-height: 38px;
  font-weight: 700;
  margin-top: 22px;
}

.activity-time {
  color: #6b8798;
  font-size: 22px;
  line-height: 32px;
  margin-top: 6px;
}

.reward-list {
  display: flex;
  margin-top: 20px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.reward-list::-webkit-scrollbar {
  display: none;
}

.reward-item {
  width: 124px;
  min-width: 124px;
  background: linear-gradient(180deg, #f4fbff 0%, #e9f8f4 100%);
  border-radius: 18px;
  padding: 14px 10px;
  text-align: center;
  margin-right: 12px;
}

.reward-img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  display: block;
  margin: 0 auto 8px;
}

.reward-day {
  color: #18a992;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
}

.reward-name {
  color: #315062;
  font-size: 20px;
  line-height: 28px;
  height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reward-remain {
  color: #f0a51d;
  font-size: 19px;
  line-height: 26px;
}

:deep(.van-empty) {
  padding-top: 70px;
}

:deep(.van-list__finished-text),
:deep(.van-list__loading) {
  color: #6b8798;
}
</style>
